import { useMutation } from '@tanstack/react-query';
import { getReqUrl, handleDataPlatformError } from '../utils';
import { DROPS_ENDPOINT } from './constants';
import dataPlatformFetch from '../../../utils/dataPlatformFetch';

export const useMakeDeposit = () => {
  return useMutation(async (variables) => {
    const url = getReqUrl(
      DROPS_ENDPOINT,
      `/deposit/${variables.reservationId}`
    );
    const res = await dataPlatformFetch(url, {
      method: 'POST',
      recaptchaToken: variables.recaptchaToken,
      correlationId: variables.correlationId,
      body: JSON.stringify({
        ...variables.updateData
      })
    });

    if (!res.ok) {
      await handleDataPlatformError(res);
    }
    return res.json();
  });
};
